import { render, staticRenderFns } from "./brand-add-or-update.vue?vue&type=template&id=f06738d6&"
import script from "./brand-add-or-update.vue?vue&type=script&lang=js&"
export * from "./brand-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports